module.exports = ".hide-me{\r\n    display: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/sign-out/sign-out.component.css
// module id = ./src/app/shared/sign-out/sign-out.component.css
// module chunks = main